export const NotificationMixin = {
  methods: {
    goto(notification) {
      if (notification.module === 'alert') {
        // this.SET_SELECTED_PLANT_ID(notification.ref_id)
        this.$router.push({'name': 'alert'})
        this.menu = false
      }
    }
  }
}
